const modalApi = {
  init(Vue) {
    Vue.$modal = this;
    Vue.prototype.$modal = this;
  },

  show(id) {
    const modal = document.getElementById(id);

    if (modal) {
      modal.showModal();

      const child = modal.__vue__.$children[0]._events["before-open"];
      const main = modal.__vue__._events["before-open"];
      const fonction = child || main;

      if (fonction) {
        fonction[0]();
      }
    }
  },

  hide(id) {
    const modal = document.getElementById(id);

    if (modal) {
      modal.classList.add("hide");

      const animationEndHandler = () => {
        modal.removeEventListener("animationend", animationEndHandler);
        modal.close();
        modal.classList.remove("hide");
      };

      modal.addEventListener("animationend", animationEndHandler);
    }
  },
};

export default (Vue) => {
  const methods = { ...modalApi };
  methods.init(Vue);
  Vue.$modal = methods;
  Vue.prototype.$modal = methods;
};
